import { useMutation } from '@apollo/client'
import { preferenceValues as savePreferenceValues } from '@interflora/ui-components/build/common/props'
import CommunicationPreferencesUI from '@interflora/ui-components/build/components/CommunciationPreferences/CommunciationPreferences'
import { SiteContext } from '@interflora/ui-components/build/utils/common'
import { useRouter } from 'next/router'
import React, { useContext, useEffect } from 'react'
import { populateTemplateValues } from 'utils/components'
import { replaceNullsWithBoolean } from 'utils/formatData'
import { UPDATE_CUSTOMER_PREFERENCES } from '../../graphql/queries'

type preferenceValues = {
  optInEmail: boolean
  optInPost: boolean
  optInOnline: boolean
  optInSms: boolean
  marketingLastUpdatedAt: string
}

const updatePreferenceTemplate = {
  optInEmail: false,
  optInPost: false,
  optInOnline: false,
  optInSms: false,
}

const CommunicationPreferences = () => {
  const router = useRouter()
  const [customerPreferences, setCustomerPreferences] = React.useState<preferenceValues>()
  const { getCustomer } = useContext(SiteContext)

  useEffect(() => {
    if (getCustomer.data?.customer) {
      const preferenceData = {
        ...replaceNullsWithBoolean(getCustomer.data.customer),
      }
      setCustomerPreferences({
        optInEmail: preferenceData.optInEmail,
        optInPost: preferenceData.optInPost,
        optInOnline: preferenceData.optInOnline,
        optInSms: preferenceData.optInSms,
        marketingLastUpdatedAt: preferenceData.marketingLastUpdatedAt,
      })
    }
  }, [getCustomer.data])

  const [savePreferences] = useMutation(UPDATE_CUSTOMER_PREFERENCES)

  const updateCustomerPreferences = async (values: savePreferenceValues) => {
    try {
      const updatePreferences = populateTemplateValues(values, updatePreferenceTemplate)
      await savePreferences({ variables: { input: updatePreferences } })
      getCustomer.refetch().then(() => router.push('/account?success=communications-preferences'))
    } catch (error) {
      throw new Error('Sorry, we could not update your marketing preferences')
    }
  }

  const onCancel = () => {
    router.replace('/account')
  }

  return getCustomer.loading || !getCustomer.data?.customer || !customerPreferences ? (
    <h1>Loading</h1>
  ) : (
    <CommunicationPreferencesUI
      {...customerPreferences}
      savePreferences={updateCustomerPreferences}
      onCancel={onCancel}
    />
  )
}

export default CommunicationPreferences
